import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { CustomRouter } from 'src/admin-front/ajs-upgraded-providers';
import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';
import { AsyncRequestService } from 'src/app/core/async-request/async-request.service';
import { API_URL_COMPANIES } from 'src/app/shared/services/basic.service';
import { ErrorHandlingService } from 'src/app/shared/services/error-handling.service';
import { environment } from 'src/environments/environment';
import { AuthorizedGoogleAccount } from '../shared/models/authorized-google-account.model';

@Injectable({
  providedIn: 'root',
})
export class GoogleBusinessProfileService {
  existingGoogleAccountAttachedToAlcmeon$: Observable<AuthorizedGoogleAccount | null>;

  constructor(
    private alcmeonContextService: AlcmeonContextService,
    private httpClient: HttpClient,
    private customRouter: CustomRouter,
    private asyncRequestService: AsyncRequestService,
    private errorHandlingService: ErrorHandlingService
  ) {}

  getAccounts(companyId, requestId, siteId, code) {
    let params = new HttpParams();
    const appendParam = (key, value) => (value ? (params = params.append(key, value)) : null);
    appendParam('request_id', requestId);
    appendParam('site_id', siteId);
    appendParam('code', code);
    return this.httpClient
      .get(`${environment.apiURLPrefix}/api/1.0/companies/${companyId}/gmb/authorized/accounts`, {
        params,
      })
      .pipe(map((result: any) => result?.accounts));
  }

  connectLocation(companyId: number, data: any) {
    return this.asyncRequestService.post(
      `${environment.apiURLPrefix}/api/1.0/companies/${companyId}/gmb/authorized/finalize`,
      data
    );
  }

  completeAuthorization(companyId: number, data: { site_id: number }) {
    return this.asyncRequestService.post(
      `${environment.apiURLPrefix}/api/1.0/companies/${companyId}/gmb/complete-authorization`,
      data
    );
  }

  getExistingGoogleAccountAttachedToAlcmeon(): Observable<AuthorizedGoogleAccount | null> {
    if (this.existingGoogleAccountAttachedToAlcmeon$) {
      return this.existingGoogleAccountAttachedToAlcmeon$;
    }
    this.existingGoogleAccountAttachedToAlcmeon$ = this.httpClient
      .get<AuthorizedGoogleAccount | null>(
        `${API_URL_COMPANIES}/${this.alcmeonContextService.companyId}/gmb/oauth-user`
      )
      .pipe(
        shareReplay(1),
        catchError(() => of(null))
      );

    return this.existingGoogleAccountAttachedToAlcmeon$;
  }

  useGoogleAccount(requestId: number) {
    this.customRouter.go('auth.alcmeon.parameters.gmb.add-account', { requestId });
  }

  connectGoogleAccount(): void {
    const url = `${API_URL_COMPANIES}/${this.alcmeonContextService.companyId}/add-account`;
    this.httpClient
      .post<string>(url, JSON.stringify('gmb'), { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) })
      .pipe(
        map(response => (window.location.href = response)),
        this.errorHandlingService.catchAlertAndThrowHttpError()
      )
      .subscribe();
  }
}
